<template>
  <select class="form-control" :required="true" v-model="selected" @change="la_schimb">
   <option v-for="(option, index) in options" v-bind:key="index" v-bind:value="option">{{ option }}</option>
  </select>
</template>

<script>
export default {
    name: 'FSelect',
    data () {
        return {
        selected: "Favorite",
        }
    },
    props: ["options", "initial"],
    methods:{
        la_schimb: function(){
            this.$emit('fselect', [this.selected,])
        }
           
    },
    mounted(){
        this.$emit('fselect', [this.initial,])
        this.selected = this.initial
    }
    

}
</script>
